import PendingDeduction from "../../services/api/PendingDeduction";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { isValNull } from "../../utils";

const handleError = (err) => {
  console.log("[handleError] Error in PendingDeduction actions", err);
};

const setPendingDeductionList = (payload) => {
  return {
    type: ActionTypes.SET_PENDING_DEDUCTION_LIST,
    payload: payload,
  };
};
export const setPendingDeductionCurrentPage = (payload) => {
  return {
    type: ActionTypes.SET_PENDING_DEDUCTION_CURRENT_PAGE,
    payload: payload,
  };
};
export const setPendingDeductionActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_PENDING_DEDUCTION_ACTIVE_FILTERS,
    payload: payload,
  };
};

export const getPendingDeductionList =
  (currentPage, activeFilters) => async (dispatch) => {
    try {
      let filterBody = {};
      let activeFiltersObj = {};
      const filterKeyObj = {
        driverId: "driver_fe_id",
        pending: "pending",
        startDate: "start_date",
        endDate: "end_date",
      };

      Object.keys(activeFilters).map((key, index) => {
        if (!isValNull(activeFilters[key])) {
          Object.assign(filterBody, {
            [filterKeyObj[key]]: activeFilters[key],
          });
          Object.assign(activeFiltersObj, {
            [key]: activeFilters[key],
          });
        }
      });
      let queryParams = new URLSearchParams(filterBody).toString();
      const response = await PendingDeduction.getPendingDeductionList(
        queryParams
      );
      if (response) {
        dispatch(setPendingDeductionList(response));
        dispatch(setPendingDeductionCurrentPage(currentPage));
        dispatch(setPendingDeductionActiveFilters(activeFiltersObj));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
